import { DEFAULT_PARTICIPANTE_FOTO } from '@/helpers/participanteFoto';
import { DEFAULT_SITE_LOGO } from '@/helpers/siteLogo';

/** Troca src quando upload da API falha (404 no Render, etc.). */
export function applyImgFallback(event, fallbackSrc) {
  const img = event?.target;
  if (!img || img.dataset.rrplFallback === '1') return;
  img.dataset.rrplFallback = '1';
  img.src = fallbackSrc;
}

export function onParticipantImgError(event) {
  applyImgFallback(event, DEFAULT_PARTICIPANTE_FOTO);
}

export function onSiteLogoImgError(event) {
  applyImgFallback(event, DEFAULT_SITE_LOGO);
}

export function onCarouselImgError(event, slide, heroFallbackSrc) {
  const img = event?.target;
  if (!img) return;
  if (img.dataset.rrplFallback === 'hero') return;
  if (img.dataset.rrplFallback !== 'desktop' && slide?.desktopSrc && img.src !== slide.desktopSrc) {
    img.dataset.rrplFallback = 'desktop';
    img.src = slide.desktopSrc;
    return;
  }
  img.dataset.rrplFallback = 'hero';
  img.src = heroFallbackSrc;
}
